import { render } from "./pencil-square.vue?vue&type=template&id=0bb3b763"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/pencil-square.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bb3b763"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bb3b763', __exports__)) {
    api.reload('0bb3b763', __exports__)
  }
  
  module.hot.accept("./pencil-square.vue?vue&type=template&id=0bb3b763", () => {
    api.rerender('0bb3b763', render)
  })

}


export default __exports__